// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1Lbh-","select":"Header_select__uJVOo","clinic":"Header_clinic__3RvFF"};